import { render, staticRenderFns } from "./workShopTemplate.vue?vue&type=template&id=5ecc6800"
import script from "./workShopTemplate.vue?vue&type=script&lang=js"
export * from "./workShopTemplate.vue?vue&type=script&lang=js"
import style0 from "./workShopTemplate.vue?vue&type=style&index=0&id=5ecc6800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports